export function mapCode(code, response){
    if (response) {
        try {
            let respObj = JSON.parse(response);
            if (respObj.errors)
                return respObj.errors.join(". ");
        } catch (error) {
            console.log(error);
        }
    }
    switch (code) {
        case 0:
            return "Не удалось связаться с сервером"
        case 401:
            return "Не удалось авторизоваться на сервере"
        case 403:
            return  "В доступе отказано, не достаточно прав"
        default:
            return "Неизвестная ошибка, код ошибки: " + code
    }
}